import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { GetLogFilesRepository } from '../../Diagnostics/Get-Log-Files/getLogFiles.repository';


@Injectable({
    providedIn: 'root',
})
export class GetLogFileService {
    constructor(private readonly _getLogFilesRepository: GetLogFilesRepository) {}

    async getLogfileLocationList(): Promise<Core.LogFileLocationViewModel[]> {
        return lastValueFrom(this._getLogFilesRepository.getLogFileLocationList());
    }

    async getLogFileList(searchModel: Core.LogFileLocationViewModel): Promise<number> {
        return lastValueFrom(this._getLogFilesRepository.getLogFileList(searchModel));
    }
    async downloadLogFile(file: Core.LogFileViewModel): Promise<number> {
        return lastValueFrom(this._getLogFilesRepository.downloadLogFile(file));
    }
}
    


